const yup = require("yup");

const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const phoneRegex = /^\+?[0-9]{10,15}$/;
const passwordRegx =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;

export const emailOrPhoneSchema = yup
  .object({
    emailOrPhone: yup
      .string()
      .required("Email or phone is required")
      .test(
        "email-or-phone",
        "Enter a valid email or phone number",
        (value) => {
          if (!value) return false;
          return emailRegex.test(value) || phoneRegex.test(value);
        },
      ),
    captchaToken: yup.string().required("Captcha missing"),
  })
  .noUnknown(true);

export const passwordSchema = yup
  .object({
    password: yup.string().required("Password is required"),
    captchaToken: yup.string().required("captcha required"),
  })
  .noUnknown(true);

export const loginWithOtpSchema = yup
  .object({
    myotp: yup
      .string()
      .required("OTP is required")
      .matches(/^[0-9]{6}$/, "OTP must be exactly 6 digits"),

    password: yup
      .string()
      .required("Password is required")
      .test(
        "password-policy",
        "Enter a valid password. Must contain one small case one capital case character, one number and one symbol",
        (value) => {
          if (!value) return false;
          return passwordRegx.test(value);
        },
      ),

    confirmPassword: yup
      .string()
      .required("Confirm password is required")
      .oneOf([yup.ref("password")], "Passwords must match"),

    captchaToken: yup.string().required("captcha required"),
  })
  .noUnknown(true);

export const loginWithMfaSchema = yup
  .object({
    otp: yup
      .string()
      .required("OTP is required")
      .matches(/^[0-9]{6}$/, "OTP must be exactly 6 digits"),

    captchaToken: yup.string().required("captcha required"),
  })
  .noUnknown(true);

export const loginSchema = yup
  .object({
    email: yup
      .string()
      .required("Email or phone is required")
      .test(
        "email-or-phone",
        "Enter a valid email or phone number",
        (value) => {
          if (!value) return false;
          return emailRegex.test(value) || phoneRegex.test(value);
        },
      ),
    password: yup.string().required("Password is required"),
    captchaToken: yup.string().required("captcha required"),
    otp: yup.string().matches(/^[0-9]{6}$/, "OTP must be exactly 6 digits"),
  })
  .noUnknown(true);

export const initiateForgotPasswordSchema = yup
  .object({
    email: yup
      .string()
      .required("Email is required")
      .test("email", "Enter a valid email", (value) => {
        if (!value) return false;
        return emailRegex.test(value);
      }),
  })
  .noUnknown(true);

export const resetPasswordSchema = yup
  .object({
    otp: yup
      .string()
      .required("OTP is required")
      .matches(/^[0-9]{6}$/, "OTP must be exactly 6 digits"),
    password: yup
      .string()
      .required("Password is required")
      .test(
        "password-policy",
        "Enter a valid password. Must contain one small case one capital case character, one number and one symbol",
        (value) => {
          if (!value) return false;
          return passwordRegx.test(value);
        },
      ),

    confirmPassword: yup
      .string()
      .required("Confirm password is required")
      .oneOf([yup.ref("password")], "Passwords must match"),

    captchaToken: yup.string().required("captcha required"),
  })
  .noUnknown(true);
